export class Google_map {
    map: any;
    flightpaths: any = [];

    public init(mapDivNativeElement: any, coord: any, zoom: number) {
        const mapProperties = {
            center: new google.maps.LatLng(coord),
            zoom: zoom,
            scaleControl: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        this.map = new google.maps.Map(mapDivNativeElement, mapProperties);
    }

    public setMarker(coord: any, title: string) {
        let marker = new google.maps.Marker({
            position: coord,
            map: this.map,
            title: title,
        });
        return marker;
    }
    public setMarkerIcon(coord: any, title: string) {
        var circleSymbol = {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 10, // the size of the circle in pixels
            fillColor: "#FF0000",
            fillOpacity: 0.35,
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2
          };

        let marker = new google.maps.Marker({
            icon: circleSymbol,
            position: coord,
            map: this.map,
            title: title,
        });
        return marker;
    }

    public addPolygon(polygon: any, strokeColor = "#FF0000") {
        const flightPath = new google.maps.Polyline({
            path: polygon,
            geodesic: true,
            strokeColor: strokeColor,
            strokeOpacity: 1.0,
            strokeWeight: 2,
        });
        flightPath.setMap(this.map);
        this.flightpaths.push(flightPath)
    }

    public removePolygon() {
        this.flightpaths.forEach((fp: any) => {
            fp.setMap(null);
            fp = null;
        })
    }
    public removeMarkers(marker: any) {
        marker.setMap(null);
    }

    public clickOnMap(callback: any) {
        this.map.addListener("click", (mapsMouseEvent: any) => {
            callback(mapsMouseEvent);
        });
    }

    public addCircle(latlng: any, radius = 100, fillcolor = "#FF0000") {
        const cityCircle = new google.maps.Circle({
            strokeColor: "#000000",
            strokeOpacity: 0.8,
            strokeWeight: 1,
            fillColor: fillcolor,
            fillOpacity: 0.35,
            map: this.map,
            center: latlng,
            radius: radius,
            clickable: false,
        });
    }
    public addCircleNoTrans(latlng: any, radius = 100, fillcolor = "#FF0000", fillOpacity = 1.0) {
        const cityCircle = new google.maps.Circle({
            strokeColor: "#000000",
            strokeOpacity: 0.8,
            strokeWeight: 1,
            fillColor: fillcolor,
            fillOpacity: fillOpacity,
            map: this.map,
            center: latlng,
            radius: radius,
            clickable: false,
        });

        return cityCircle
    }

    public scaleToZoom(meter: number) {
        let convertion = [
            { zoom: 19, scale: 1128 },
            { zoom: 18, scale: 2256 },
            { zoom: 17, scale: 4513 },
            { zoom: 16, scale: 9027 },
            { zoom: 15, scale: 18055 },
            { zoom: 14, scale: 36111 },
            { zoom: 13, scale: 72223 },
            { zoom: 12, scale: 144447 },
            { zoom: 11, scale: 288895 },
            { zoom: 10, scale: 577790 },
            { zoom: 9, scale: 1155581 },
            { zoom: 8, scale: 2311162 },
            { zoom: 7, scale: 4622324 },
            { zoom: 6, scale: 9244649 },
            { zoom: 5, scale: 18489298 },
            { zoom: 4, scale: 36978596 },
            { zoom: 3, scale: 73957193 },
            { zoom: 2, scale: 147914387 },
            { zoom: 1, scale: 295828775 },
            { zoom: 0, scale: 591657550 },
        ]
        let zoom = 19
        convertion.forEach((c: any) => {
            if (c.scale < meter) zoom = c.zoom
        });
        return zoom
    }
}